<template>
  <vx-card class="min-h-screen">
    <ResponseAlert ref="response" />
    <vs-table
			:sst="true"
			@sort="sort"
            :data="config.rows"
		>
      <template slot="header">
        <vs-row>
          <vs-col class="mt-5" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <vs-row class="mb-5" vs-align="flex-end" vs-type="flex" vs-justify="flex-end" vs-w="12">
              <vs-col class="mr-auto" vs-lg="2" vs-sm="3" vs-xs="12">
                <vs-button :to="'/'+config.uri+'/'+ $route.params.userId +'/coin-history/add'" class="w-full" color="primary" type="filled" icon="add">Add Coin
                </vs-button>
              </vs-col>
              <vs-col class="history ml-auto" vs-lg="2" vs-sm="3" vs-xs="12" style="text-align: right;">
                <router-link :to="`/${config.uri}/${$route.params.userId}`" class="font-bold">
                  Back to detail
                </router-link>
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </template>
      <template slot="thead">
        <vs-th :sort-key="row.value" v-for="(row, key) in config.headers" :key="key" :width="row.width"
          :class="row.class">
          {{ row.title }}
        </vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          
          <vs-td :data="data[indextr].createdAt">
            {{ moment(data[indextr].createdAt).format('DD-MMM-YYYY')}}
          </vs-td>
          <vs-td :data="data[indextr].type">
            {{ data[indextr].type }}
          </vs-td>
          <vs-td :data="data[indextr].amount">
            {{ data[indextr].amount }}
          </vs-td>
          <vs-td :data="data[indextr].notes">
            <p class="text-limit-2">{{ data[indextr].notes || "-" }}</p>
          </vs-td>
          <vs-td :data="data[indextr].createdBy">
            {{ data[indextr].createdBy }}
          </vs-td>

          <vs-td class="flex">
            <router-link :to='`/${config.uri}/${$route.params.userId}/coin-history/edit/${data[indextr].id}`' class="text-black text-opacity-50">
              <feather-icon icon="EditIcon" svgClasses="w-5 h-5 mr-3 stroke-current cursor-pointer" />
            </router-link>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <Pagination :config="config" @gotoPage="gotoPage" />

  </vx-card>
</template>
<style>
.text-limit-2{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
            line-clamp: 2;
    -webkit-box-orient: vertical;
}
</style>
<script>
	import moment from 'moment'
  export default {
    name: 'ListCoinHistory',
    data() {
      return {
        config: {
          uri: this.$route.meta.link,
          api: `brand-ambasador/${this.$route.params.userId}/coin-histories`,
          rows: [],
          total_data: 0,
          total_page: 0,
          per_page: 10,
          page: 1,
          orderby: "id",
          sort: "desc",
          debounce: null,
          headers: [{
            title: "Created At",
            value: 'createdAt',
            align: "text-left",
            width: "20%",
          },{
            title: "Type",
            value: "type",
            align: "text-left",
            width: "20%",
          }, {
            title: "Amount",
            value: "amount",
            align: "text-left",
            width: "20%",
          }, {
            title: "Note",
            value: "notes",
            align: "text-left",
            width: "20%",
          }, {
            title: "Created By",
            value: "createdBy",
            align: "text-left",
            width: "20%",
          }, {
            title: "Action",
            value: "",
            class: "text-center",
            width: "20%",
          }],
        },
        moment
      }
    },
    created() {
      const _ = this;
      _.get();
    },
    watch: {
      'config.per_page'() {
        this.config.page = 1
        this.get()
      }
    },
    methods: {
      get() {
        this.$table.get(this.config)
      },
      sort(orderby) {
        if (orderby !== "") this.$table.sort(this.config, orderby)
      },
      gotoPage(page) {
        this.$table.gotoPage(this.config, page)
      },
    },
  }

</script>

<style>

</style>
